<div class="header">
    <sew-headline level="2" translate>SEARCH.PAGE.HEADLINE</sew-headline>
    <!-- TODO: Beta Test rollback -->
    <!-- <sew-button class="wishlist" hierarchy="tertiary" icon="star" style="display: none; height: 0">
        <button>{{ 'PRODUCT.WISHLIST_OPEN' | translate }}</button>
    </sew-button> -->
</div>

<ecs-search></ecs-search>

<div class="result-wrapper">
    <sew-notification-stack
        #notificationStack
        class="limit-exceeded"
        direction="appendChild"
        [ngClass]="{
            hide: (isVisible | async) === false && searchResultType === searchResultTypes.TYPE_DESIGNATION,
        }"
    >
    </sew-notification-stack>

    <router-outlet name="result" #resultOutlet="outlet"></router-outlet>

    @if (!resultOutlet.isActivated) {
        <ecs-request-replacement-product></ecs-request-replacement-product>
    }

    <!-- if no result route is loaded, show supplies & services -->
    @if (
        !resultOutlet.isActivated && availableTabs && (availableTabs | withLoading | async);
        as availableTabsResult
    ) {
        @if (availableTabsResult.value) {
            <ecs-supplies-services
                [activeTab]="activeTab"
                [availableTabs]="availableTabsResult.value"
            ></ecs-supplies-services>
        }
        @if (availableTabsResult.loading) {
            <div class="services-skeleton">
                <sew-skeleton class="heading"></sew-skeleton>
                @for (i of skeletonServicesContentElements; track i) {
                    <div class="flex">
                        <sew-skeleton class="element-picture"></sew-skeleton>
                        <div class="content">
                            <sew-skeleton class="element-heading"></sew-skeleton>
                            <sew-skeleton class="element-line"></sew-skeleton>
                            <sew-skeleton class="element-line"></sew-skeleton>
                            <sew-skeleton class="element-line"></sew-skeleton>
                            <sew-skeleton class="element-button"></sew-skeleton>
                        </div>
                    </div>
                }
            </div>
        }
    }
</div>

<!-- TODO add expression for asynchronous loading -->
<!-- TODO: Beta Test rollback -->
@if (true) {
    <div class="side-column" style="display: none; height: 0">
        <div class="template"><h3>_Vorlagen_</h3></div>
        <div class="offers-orders"><h3>_Letzte Bestellungen & Angebote_</h3></div>
        @if (!isMobile) {
            <div class="services"><h3>_Unsere Services_</h3></div>
        }
    </div>
} @else {
    <div class="side-column">
        <div class="template-skeleton">
            <ng-container *ngTemplateOutlet="listSkeleton"></ng-container>
        </div>
        <div class="offers-orders-skeleton">
            <ng-container *ngTemplateOutlet="listSkeleton"></ng-container>
        </div>
    </div>
}
<div class="side-column">
    <ecs-whats-new></ecs-whats-new>
</div>

<!-- Skeletons -->

<ng-template #listSkeleton>
    <sew-skeleton class="heading"></sew-skeleton>
    @for (i of skeletonListRowCount; track i) {
        <sew-skeleton class="entry"></sew-skeleton>
    }
</ng-template>
